import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const SearchFormWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
    width: 100%;
    padding: 0;
    margin-top: 10px;
    margin-bottom: 20px;
    flex-grow: 1;
    overflow: visible;
    align-items: end;
    justify-items: stretch;

    > * {
        min-width: 0;
        width: 100%;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
        padding: 8px 0 0;
        gap: 12px;
    }
`;

export const SearchActionsRow = styled.div`
    grid-column: 1 / -1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-top: 6px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-direction: column;
        align-items: stretch;

        > button {
            width: 100%;
        }
    }
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 10px;
    background-color: #2b2b2b;
    border: 1px solid #707070;
    margin-top: 5px;
    border-radius: 3px;
    color: #fff;
    font-size: ${({ theme }) => theme.fontSizes.medium};

    &::placeholder {
        color: #8f8f8f;
    }
`;

export const SearchSelect = styled.select`
    width: 100%;
    padding: 11.5px;
    margin-top: 5px;
    border-radius: 3px;
    background-color: #2b2b2b;
    border: 1px solid #707070;
    color: #8f8f8f;
    font-size: ${({ theme }) => theme.fontSizes.medium};

    option {
        color: ${({ theme }) => theme.colors.textSecondary};
    }

    appearance: auto;

    &::placeholder {
        color: #8f8f8f;
    }
`;

export const SearchDatePickerInput = styled.input`
    margin-top: 5px;
    padding: 10px;
    border: 1px solid #707070;
    border-radius: 3px;
    width: 100%;
    background-color: #2b2b2b;
    color: #fff;

    &::placeholder {
        color: #8f8f8f;
    }
`;

export const Button = styled.button`
    padding: 10px 20px;
    background-color: #40a31e;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        background-color: #45a049;
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const SearchButtonWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 35px;
    gap: 10px;
`;

export const PackageViewButton = styled(IconButton)`
    width: 36px;
    height: 36px;
    align-self: flex-end;
    display: none;

    @media (min-width: 1008px) {
        display: inline-flex;
    }
`;